import React from 'react';

import AppkitIcon from '../../../../../shared/displayComponents/appkitIcon/appkitIcon.component';
import { ValidateAttachmentsResponse } from '../../../../../../../common/types';

import styles from './invalidAttachmentsWarning.module.scss';

interface InvalidAttachmentsWarningProps {
  invalidAttachments: ValidateAttachmentsResponse[];
}

const InvalidAttachmentsWarning = ({ invalidAttachments }: InvalidAttachmentsWarningProps) => {
  return (
    <div className={styles.invalidAttachmentsWarningContainer}>
      <div>
        <AppkitIcon
          className={styles.invalidAttachmentsWarningIcon}
          icon="alert"
          type="fill"
          size={32}
        />
        <p>The following file(s) are missing the .pdf extension in their Submission File Name:</p>
      </div>
      <ul>
        {invalidAttachments.map((att: ValidateAttachmentsResponse) => (
          <li key={att.submissionFileName}>[{att.submissionFileName}]</li>
        ))}
      </ul>
      <p>
        Please update the Submission File Name to include the .pdf extension to ensure proper
        processing.
      </p>
    </div>
  );
};

export default InvalidAttachmentsWarning;
